/**
 * Copyright (c) 2025 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : core.jsx
 * description   : {{insert here}}
 * creation date : 12/04/2025
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    route_list,
    hash_list,
} from '@/utils/router/core';



// --------------------------------------------------------------------------------
//      CONSTANTS DEFINITION
// --------------------------------------------------------------------------------

// TODO: Translate message
const config_page_HOME =
{
    label: {
        navbar: 'Home',
        get footer() {
            return this.navbar;
        },
    },
    is_private: false,
    path: route_list.HOME,
    search: {},
    hash: [],
};

// TODO: Translate message
const config_page_HOME_about =
{
    label: {
        navbar: 'About',
        get footer() {
            return this.navbar;
        },
    },
    is_private: false,
    path: route_list.HOME,
    search: {},
    hash:
        [
            hash_list.ABOUT
        ],
};

// TODO: Translate message
const config_page_HOME_service =
{
    label: {
        navbar: 'Service',
        get footer() {
            return this.navbar;
        },
    },
    is_private: false,
    path: route_list.HOME,
    search: {},
    hash:
        [
            hash_list.SERVICE
        ],
};

// TODO: Translate message
const config_page_HOME_process =
{
    label: {
        navbar: 'Process',
        get footer() {
            return this.navbar;
        },
    },
    is_private: false,
    path: route_list.HOME,
    search: {},
    hash:
        [
            hash_list.PROCESS
        ],
};

// TODO: Translate message
const config_page_HOME_clients =
{
    label: {
        navbar: 'Clients',
        get footer() {
            return this.navbar;
        },
    },
    is_private: false,
    path: route_list.HOME,
    search: {},
    hash:
        [
            hash_list.CLIENTS
        ],
};

// TODO: Translate message
const config_page_HOME_contact =
{
    label: {
        navbar: 'Contact',
        get footer() {
            return this.navbar;
        },
    },
    is_private: false,
    path: route_list.HOME,
    search: {},
    hash:
        [
            hash_list.CONTACT
        ],
};

// TODO: Translate message
const config_page_ACCOUNT =
{
    label: {
        navbar: 'Account',
        get footer() {
            return this.navbar;
        },
    },
    is_private: false,
    path: route_list.ACCOUNT,
    search: {},
    hash: [],
};

// TODO: Translate message
const config_page_LEGAL =
{
    label: {
        navbar: 'Terms and conditions',
        get footer() {
            return this.navbar;
        },
    },
    is_private: false,
    path: route_list.LEGAL,
    search: {},
    hash: [],
};

// TODO: Translate message
const config_page_PRIVACY =
{
    label: {
        navbar: 'Privacy notice',
        get footer() {
            return this.navbar;
        },
    },
    is_private: false,
    path: route_list.PRIVACY,
    search: {},
    hash: [],
};

// TODO: Translate message
const config_page_COOKIES =
{
    label: {
        navbar: 'Cookie policy',
        get footer() {
            return this.navbar;
        },
    },
    is_private: false,
    path: route_list.COOKIES,
    search: {},
    hash: [],
};

// TODO: Translate message
const config_page_CONTACT =
{
    label: {
        navbar: 'Contact',
        get footer() {
            return this.navbar;
        },
    },
    is_private: false,
    path: route_list.CONTACT,
    search: {},
    hash: [],
};

// TODO: Translate message
const config_page_DEMO =
{
    label: {
        navbar: 'Demo',
        footer: 'Home page',
    },
    is_private: true,
    path: route_list.DEMO,
    search: {},
    hash: [],
};

const config_page_LIST_land_pages =
    [
        config_page_HOME,
        config_page_ACCOUNT,
        config_page_LEGAL,
        config_page_PRIVACY,
        config_page_COOKIES,
        config_page_CONTACT,
        config_page_DEMO,
    ];



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export {
    config_page_HOME,
    config_page_HOME_about,
    config_page_HOME_service,
    config_page_HOME_process,
    config_page_HOME_clients,
    config_page_HOME_contact,
    config_page_ACCOUNT,
    config_page_LEGAL,
    config_page_PRIVACY,
    config_page_COOKIES,
    config_page_CONTACT,
    config_page_DEMO,
    config_page_LIST_land_pages,
};



// End of file
